import axios from 'axios'
import Utils from '../services/Utils'

export default {
    getAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).storage
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).storage
        return 'Basic ' + window.btoa(user + ':' + password)
    },
    sendFile(data, callback) {
        axios.post(axios.defaults.storageApiUrl + 'file?' (data.base64 ? 'base64=true&' : '') + (data.compressed ? 'compressed=1&' : '') + 'lng=' + window.language,
            data.file, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    deleteFile(id, callback) {
        axios.delete(axios.defaults.storageApiUrl + 'file?id=' + id + '&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    convertImageHeicToPng(file, callback) {
        const formData = new FormData()
        formData.append('file', file)
        axios.post(axios.defaults.storageApiUrl + 'file/convert/heic?lng=' + window.language,
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-Data-Type': 'image/heic',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
}
